import { render } from "./TreeFile.vue?vue&type=template&id=12d677ac&ts=true"
import script from "./TreeFile.vue?vue&type=script&lang=ts"
export * from "./TreeFile.vue?vue&type=script&lang=ts"

import "./TreeFile.vue?vue&type=style&index=0&id=12d677ac&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__